import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import AutoQuery from "servicestack/auto-query/auto-query";
import groupBy from "lodash/groupBy";
import resolve from "ioc/resolve";
import keyBy from "lodash/keyBy";
import labels from "emun.auth/users/_labels";
import required from "emun.auth/users/_required";
import config from "emun.auth/users/_config";
import authConfig from "emun.auth/auth.config"; //get shared
import LocationPicker from "emun.auth/users/location-picker";
import RetailerPicker from "emun.auth/users/customer-picker";

const { ALL_PERMISSIONS } = config;

export default class UserFeildsetController {
  constructor($scope) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.permissionOpen = false;
    if (!$ctrl.bus) {
      $ctrl.bus = new ServiceBus();
    }
    $ctrl.bus.read("GetRolePermissions.json").then((res) => {
      $ctrl.rolePermissions = res.data;
      $ctrl.onRoleChanged($ctrl.request && $ctrl.request.role, true);
    });
    $ctrl.bus
      .read("QueryPermissionLists.json")
      .then((res) => ($ctrl.permissionLists = res.data.results));
    $ctrl.bus.send("QueryRoles.json").then((res) => {
      $ctrl.roles = res.data.results;
      $ctrl.roles.forEach(
        (r) =>
          ($ctrl["is" + r.code] = () =>
            $ctrl.request && $ctrl.request.role === r.code)
      );
    });
    $ctrl.regions = new AutoQuery({
      url: "QueryRegions.json",
      orderBy: "Name",
      autoLoad: true,
      pageSize: 1000,
    });
    $ctrl.repGroups = new AutoQuery({
      url: "QueryRepGroups.json",
      orderBy: "Name",
      autoLoad: true,
      pageSize: 1000,
    });
    $ctrl.commissionGroups = new AutoQuery({
      url: "QueryCommissionGroups.json",
      orderBy: "Name",
      autoLoad: true,
      pageSize: 1000,
    });
    $scope.$watch(
      () => $ctrl.request && $ctrl.request.primaryEmail,
      $ctrl.primaryEmailChanged.bind($ctrl)
    );
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.labels = Object.assign({}, labels, $ctrl.overrideLabels);
    $ctrl.required = required;
    $ctrl.config = authConfig;
    if (
      $ctrl.request &&
      $ctrl.request.retailerId &&
      $ctrl.request.meta &&
      $ctrl.request.meta.RetailerLimitLocations
    )
      $ctrl.loadLocations();
    $ctrl.retailerBillTos = [];
    if ($ctrl.request.meta && $ctrl.request.meta.RetailerBillTos) {
      $ctrl.retailerBillTos = JSON.parse($ctrl.request.meta.RetailerBillTos);
    }
  }

  findRetailers(val) {
    let $ctrl = this;
    let url = `BrowseRetailers.json?Take=15&JsConfig=ExcludeDefaultValues&Search=${val}&OrderBy=Id`; //
    return $ctrl.bus.send(url).then((res) => res.data.results);
  }

  setRetailer(retailer) {
    const $ctrl = this;
    if (!retailer) retailer = {};
    $ctrl.request.retailerId = retailer.id;
    $ctrl.request.company = $ctrl.request.companyName = retailer.companyName;
    $ctrl.clearBillTos();
    // if ($ctrl.request.meta && $ctrl.request.meta.RetailerLimitLocations) {
    //   $ctrl.loadLocations();
    // }
  }

  findReps(val) {
    let $ctrl = this;
    let url = `QuerySalesReps.json?Take=15&JsConfig=ExcludeDefaultValues&Search=${val}&OrderBy=Id`; //
    return $ctrl.bus.send(url).then((res) => res.data.results);
  }

  loadLocations() {
    let $ctrl = this;
    let url = `QueryRetailerShippingLocations.json?Status=Active&Take=1000&RetailerId=${$ctrl.request.retailerId}&IdIn=${$ctrl.request.meta.RetailerLimitLocations}`;
    return $ctrl.bus
      .send(url)
      .then((res) => ($ctrl.locations = res.data.results));
  }

  setRep(rep) {
    const $ctrl = this;
    if (!rep) rep = {};
    $ctrl.request.salesRepId = rep.id;
    $ctrl.request.salesRepName = rep.name;
    if (!$ctrl.request.address) $ctrl.request.address = rep.address;
    if (!$ctrl.request.city) $ctrl.request.city = rep.city;
    if (!$ctrl.request.zip) $ctrl.request.zip = rep.zip;
    if (!$ctrl.request.phone) $ctrl.request.phone = rep.phone;
    if (!$ctrl.request.email) $ctrl.request.email = rep.email;
    if (!$ctrl.request.fullName) $ctrl.request.fullName = rep.name;
    if (!$ctrl.request.displayName) $ctrl.request.displayName = rep.name;
    if (!$ctrl.request.userName) $ctrl.request.userName = rep.userName;
  }

  findManagers(val) {
    let $ctrl = this;
    let url = `QueryUsers.json?Take=15&JsConfig=ExcludeDefaultValues&RoleLookup=Manager&Search=${val}&OrderBy=Id`; //
    return $ctrl.bus.send(url).then((res) => res.data.results);
  }
  setManager(manager) {
    const $ctrl = this;
    if (!manager) manager = {};
    console.info("manager Id", manager.salesRepId);
    $ctrl.request.salesRep.manager = manager.salesRepId;
    //$ctrl.request.vendorName = vendor.vendorName;
  }

  findVendors(val) {
    let $ctrl = this;
    let url = `QueryVendors.json?Active=1&Take=15&JsConfig=ExcludeDefaultValues&Search=${val}&OrderBy=Label`; //
    return $ctrl.bus.send(url).then((res) => res.data.results);
  }
  setVendor(vendor) {
    const $ctrl = this;
    if (!vendor) vendor = {};
    $ctrl.request.vendorId = vendor.id;
    $ctrl.request.vendorName = vendor.vendorName;
  }
  findRepGroups(val) {
    let $ctrl = this;
    let url = `QueryRepGroups.json`; //
    return $ctrl.bus.send(url).then((res) => res.data.results);
  }
  setRepGroup(repGroup) {
    const $ctrl = this;
    if (!repGroup) repGroup = {};
    $ctrl.request.repGroupId = repGroup.id;
    $ctrl.request.repGroupName = repGroup.name;
  }
  onRoleChanged(forRole, initialLoad) {
    const $ctrl = this;
    $ctrl.bus
      .read("QueryPermissions.json", { forRole, orderBy: "GroupName,Name" })
      .then((res) => {
        const r = $ctrl.rolePermissions[$ctrl.request.role] || [];
        const filtered = res.data.results.filter((p) => r.indexOf(p.code) >= 0);
        $ctrl.permissionsByCode = keyBy(filtered, "code");
        $ctrl.permissions = groupBy(filtered, "groupName");
        if (!forRole || !initialLoad) {
          $ctrl.request.permissions = filtered
            .filter((p) => p.code === ALL_PERMISSIONS)
            .map((p) => p.code);
        } else if (initialLoad) {
          $ctrl.request.permissions.forEach((code) =>
            $ctrl.togglePermission(code, true)
          );
        }
        if ($ctrl.request.role == "Retailer") {
          if ($ctrl.request.meta) {
            if ($ctrl.request.meta.UseMsrpMultiplier == "true") {
              $ctrl.request.retailerPricing = "MsrpMultiplier";
            } else if ($ctrl.request.meta.DealerPricing == "true") {
              $ctrl.request.retailerPricing = "DealerPricing";
            } else if ($ctrl.request.meta.UseMsrp == "true") {
              $ctrl.request.retailerPricing = "Msrp";
            } else {
              $ctrl.request.retailerPricing = "Msrp";
            }
          }
        }
      });
  }
  togglePermission(code, checked) {
    const $ctrl = this;
    const rolePermissions = Object.keys($ctrl.permissionsByCode);

    resolve("$timeout")(() => {
      const hasAP = $ctrl.request.permissions.indexOf(ALL_PERMISSIONS) >= 0;
      if (code === ALL_PERMISSIONS) {
        $ctrl.request.permissions = checked ? rolePermissions : [];
      } else if (!checked && hasAP) {
        $ctrl.request.permissions = $ctrl.request.permissions.filter(
          (p) => p !== ALL_PERMISSIONS
        );
      }
    }, 8);
  }
  applyPermissionList(list) {
    const $ctrl = this;
    $ctrl.request.permissions = list.permissions.filter(
      (p) => p in $ctrl.permissionsByCode
    );
    $ctrl.request.permissions.forEach((code) =>
      $ctrl.togglePermission(code, true)
    );
  }
  primaryEmailChanged() {
    const $ctrl = this;
    console.debug("primaryEmailChanged", $ctrl.request);
    if ($ctrl.labels.primaryEmail && !$ctrl.labels.email)
      $ctrl.request.email = $ctrl.request.primaryEmail;
  }

  addTag() {
    const $ctrl = this;
    if ($ctrl.newTagKind) {
      if (!$ctrl.request.tags) {
        $ctrl.request.tags = {};
      }
      $ctrl.request.tags[$ctrl.newTagKind] = [];
      delete $ctrl.newTagKind;
    }
  }

  selectAllLocations() {
    let $ctrl = this;
    $ctrl.request.meta.RetailerLimitLocations = "";
  }
  selectLocations() {
    let $ctrl = this;
    $ctrl.locationIds = [];

    return LocationPicker({
      title: "Select Locations...",
      subTitle: "",
      applyTagsButtonText: false,
      single: false,
      viewSelections: false,
      criteria: {
        RetailerId: $ctrl.request.retailerId,
      },
    }).then((result) => {
      console.debug("location ids", result);
      $ctrl.request.meta.RetailerLimitLocations = result.join(",");
      //$ctrl.loadLocations();
    });
  }
  clearBillTos() {
    let $ctrl = this;
    $ctrl.retailerBillTos = [];
    $ctrl.request.meta.RetailerBillTos = "";
  }
  selectBillTos() {
    let $ctrl = this;

    return RetailerPicker({
      size: "xl",
      title: "Select Retailers...",
      subTitle: "",
      applyTagsButtonText: false,
      hideApplyTags: true,
      hideAddNote: true,
      single: false,
      viewSelections: false,
    }).then((result) => {
      console.debug("reetailer ids", result);
      if (result) {
        $ctrl.bus
          .send("QueryRetailers.json?IdIn=" + Object.keys(result).join(","))
          .then(function (res) {
            $ctrl.retailerBillTos = [];
            res.data.results.forEach(function (r) {
              $ctrl.retailerBillTos.push({
                id: r.id,
                companyName: r.companyName,
              });
            });
            $ctrl.request.meta.RetailerBillTos = JSON.stringify(
              $ctrl.retailerBillTos
            );
            $ctrl.request.retailerId = "";
            $ctrl.request.companyName = "";
          });
      } else {
        $ctrl.request.meta.RetailerBillTos = "";
      }
    });
  }
}
